import { useState } from "react";

function LisaAsukoht({ lisaKoht }) {
  const [nimetus, setNimetus] = useState("");
  const [lat, setLat] = useState(0.0);
  const [long, setLong] = useState(0.0);

  const andmeteLisamine = (event) => {
    event.preventDefault();
    console.log("Lisa linn " + nimetus);
    lisaKoht(nimetus, lat, long);
    setNimetus("");
    setLat(0);
    setLong(0);
  };

  return (
    <form onSubmit={andmeteLisamine}>
      <div className="col-3">
        <label>Nimi</label>
        <input
          type="text"
          value={nimetus}
          onChange={({ target }) => setNimetus(target.value)}
        />
      </div>
      <div className="col-3">
        <label>Pikkuskraad</label>
        <input
          type="text"
          value={lat}
          onChange={({ target }) => setLat(target.value)}
        />
      </div>
      <div className="col-3">
        <label>Laiuskraad</label>
        <input
          type="text"
          value={long}
          onChange={({ target }) => setLong(target.value)}
        />
      </div>
      <input type="submit" value="Lisa" />
    </form>
  );
}

export default LisaAsukoht;
